import * as Actions from "../redux/providerSession";
import * as AdminSessionActions from "../redux/adminSession";
import * as OmniDataAPI from "../../data/omniDataAPI";
import * as UserSessionActions from "../redux/userSession";

import { call, put, select, takeLatest } from "redux-saga/effects";
import { getIdByRelationshipType, isValidUUID } from "../../utils/helpers";

import constants from "../../assets/constants";
import { v4 as uuid } from "uuid";

export function* loadProviderODM({ payload }) {
  try {
    //clear out the existing information
    yield put(Actions.setProviderODMRequest(null));
    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let providerODM = yield call(OmniDataAPI.getProvider, payload);

      if (providerODM == null) {
        yield put(Actions.providerSessionRequestFailed("OmniDataAPI.getProvider FAILED"));
      } else {
        yield put(Actions.setProviderODMRequest(providerODM));
        yield put(Actions.loadProviderODMSuccess());
      }
    } else {
      yield put(Actions.providerSessionRequestFailed("Bad Provider _id"));
    }
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* setProviderODM({ payload }) {
  try {
    //Validate Object
    //Do all ancillary data loads here

    if (payload == null) {
      //clear out set items
      yield put(Actions.setProviderAssessmentsRequest(null));
      yield put(Actions.setProviderPatientsRequest(null));
    } else {
      //Do all ancillary data loads here
      yield put(Actions.loadProviderAssessmentsRequest(payload._id));
      yield put(Actions.loadProviderPatientsRequest(payload._id));
    }

    yield put(Actions.setProviderODMSuccess(payload));
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* updateProvider({ payload }) {
  try {
    if (payload._id == null) {
      //CREATE
      payload._id = uuid();
      let newProvider = yield call(OmniDataAPI.createProvider, payload);
      if (newProvider == null) {
        yield put(Actions.providerSessionRequestFailed("OmniDataAPI.createProvider FAILED"));
      } else {
        yield put(Actions.setProviderODMRequest(newProvider));
        yield put(Actions.updateProviderSuccess());
        yield put(AdminSessionActions.reflectUpdatedProviderODMRequest(newProvider));
      }
    } else if (isValidUUID(payload._id)) {
      //UPDATE
      let newProvider = yield call(OmniDataAPI.updateProvider, payload);
      if (newProvider == null) {
        yield put(Actions.providerSessionRequestFailed("OmniDataAPI.createProvider FAILED"));
      } else {
        yield put(Actions.setProviderODMRequest(newProvider));
        yield put(Actions.updateProviderSuccess());
        yield put(AdminSessionActions.reflectUpdatedProviderODMRequest(newProvider));

        yield put(UserSessionActions.reflectUpdatedUserODMRequest(newProvider));
      }
    } else {
    }
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* deleteProvider({ payload }) {
  try {
    //payload is UUID
    if (isValidUUID(payload)) {
      const provider = yield select(Actions.providerODMSelector);
      let deletedProvider = yield call(OmniDataAPI.deleteProvider, payload);
      if (deletedProvider == null) {
        yield put(Actions.deleteProviderSuccess(provider));
        //this method assumes that an ID alone is a delete
        yield put(AdminSessionActions.reflectUpdatedProviderODMRequest(provider));
      }
    }
    const providerODM = yield select(Actions.providerODMSelector);
    if (providerODM != null && payload === providerODM._id) {
      yield put(Actions.setProviderODMRequest(null));
    } else {
      yield put(Actions.providerSessionRequestFailed("deleteProvider: invalid UUID()"));
    }
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* loadProviderAssessments({ payload }) {
  try {
    if (isValidUUID(payload)) {
      //payload is a valid UUID

      let assessments = yield call(OmniDataAPI.getAllAssessmentByRelatedID, payload);
      // assessments = assessments.items;

      let theReturn = assessments;
      theReturn = theReturn.reduce((unique, o) => {
        if (!unique.some(obj => obj._id === o._id)) {
          unique.push(o);
        }
        return unique;
      }, []);

      yield put(Actions.loadProviderAssessmentsSuccess());
      yield put(Actions.setProviderAssessmentsRequest(theReturn));
    } else {
      yield put(Actions.providerSessionRequestFailed("loadProviderAssessments: Invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* setProviderAssessments({ payload }) {
  try {
    //Validate Object
    yield put(Actions.setProviderAssessmentsSuccess(payload));
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* reflectUpdatedAssessmentODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.providerAssessmentsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedAssessmentODMSuccess(newList));
      }
    } else {
      const providerODM = yield select(Actions.providerODMSelector);
      if (
        providerODM != null &&
        (providerODM._id ===
          getIdByRelationshipType(
            payload.omniRelationships.relatedData,
            constants.omniRelationshipTypes.assessmentSubject
          ) ||
          providerODM._id ===
            getIdByRelationshipType(
              payload.omniRelationships.relatedData,
              constants.omniRelationshipTypes.assessmentProctor
            ))
      ) {
        const currentList = yield select(Actions.providerAssessmentsSelector);
        const newList =
          currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
        newList.push(payload);
        yield put(Actions.reflectUpdatedAssessmentODMSuccess(newList));
      }
    }
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* loadProviderPatients({ payload }) {
  try {
    if (isValidUUID(payload)) {
      let allPatients = [];
      allPatients = yield call(OmniDataAPI.getAllPatientsByRelatedId, payload);

      //strip out everything not "patientPartner relationships"
      let providerPatients = allPatients.filter(obj =>
        obj.omniRelationships.relatedData.some(
          e =>
            e._id === payload &&
            e.omniRelationshipType === constants.omniRelationshipTypes.patientPartner
        )
      );
      //Check for Proxy Patient, this is an optimization, a load patients always gets called
      //there is one of these in provider session too
      let proxyPatient = allPatients.filter(obj =>
        obj.omniRelationships.relatedData.some(
          e =>
            e._id === payload &&
            e.omniRelationshipType === constants.omniRelationshipTypes.proxyPatient
        )
      );

      if (proxyPatient.length > 0) {
        yield put(UserSessionActions.setProxyPatientODMRequest(proxyPatient[0]));
      }

      yield put(Actions.loadProviderPatientsSuccess());
      yield put(Actions.setProviderPatientsRequest(providerPatients));
    } else {
      yield put(Actions.providerSessionRequestFailed("loadProviderPatients: Invalid UUID"));
    }
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* setProviderPatients({ payload }) {
  try {
    //Validate Object
    yield put(Actions.setProviderPatientsSuccess(payload));
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}

export function* reflectUpdatedPatientODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.providerPatientsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedPatientODMSuccess(newList));
      }
    } else {
      const currentList = yield select(Actions.providerPatientsSelector);
      const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list

      const userODMSelector = yield select(UserSessionActions.userODMSelector);
      const filtered = payload.omniRelationships.relatedData.filter(
        element =>
          element._id === userODMSelector._id &&
          element.type === constants.onboardingUserType.provider &&
          element.omniRelationshipType === constants.omniRelationshipTypes.patientPartner
      );
      if (filtered.length > 0) {
      newList.push(payload);
      }

      yield put(Actions.reflectUpdatedPatientODMSuccess(newList));

      const currentUserODM = yield select(UserSessionActions.userODMSelector);
      if (
        currentUserODM &&
        payload.omniRelationships.relatedData.some(
          e =>
            e._id === currentUserODM._id &&
            e.omniRelationshipType === constants.omniRelationshipTypes.proxyPatient
        )
      ) {
        yield put(UserSessionActions.setProxyPatientODMRequest(payload));
      }
    }
  } catch (error) {
    yield put(Actions.providerSessionRequestFailed(error));
  }
}
//  saga
export default function* providerDataSaga() {
  yield takeLatest(Actions.loadProviderODMRequest, loadProviderODM);
  yield takeLatest(Actions.setProviderODMRequest, setProviderODM);
  yield takeLatest(Actions.updateProviderRequest, updateProvider);
  yield takeLatest(Actions.deleteProviderRequest, deleteProvider);

  yield takeLatest(Actions.loadProviderAssessmentsRequest, loadProviderAssessments);
  yield takeLatest(Actions.setProviderAssessmentsRequest, setProviderAssessments);
  yield takeLatest(Actions.reflectUpdatedAssessmentODMRequest, reflectUpdatedAssessmentODM);

  yield takeLatest(Actions.loadProviderPatientsRequest, loadProviderPatients);
  yield takeLatest(Actions.setProviderPatientsRequest, setProviderPatients);
  yield takeLatest(Actions.reflectUpdatedPatientODMRequest, reflectUpdatedPatientODM);
}
